import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import CaseStudyHero from './components/CaseStudyHero';
import CaseStudyList from './components/CaseStudyList';
import TestimonialsSection from './components/TestimonialsSection';
import CTASection from './components/CTASection';
import { useSEO } from '../../utils/seo';

export function CaseStudyPage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://brandcapital.it';
  
  useSEO({
    title: 'Case Study - Esempi Valutazione Brand e Perizie Certificate Italia',
    description: 'Scopri i case study di successo: esempi reali di valutazione brand, perizie certificate e risultati ottenuti. Testimonianze di aziende, commercialisti e investitori che hanno valorizzato il loro brand.',
    keywords: 'case study valutazione brand, esempi perizie brand, testimonianze clienti, risultati valutazione',
    canonical: `${siteUrl}/case-study`,
    schema: {
      '@context': 'https://schema.org',
      '@type': 'CollectionPage',
      name: 'Case Study - Valutazioni Brand',
      description: 'Raccolta di case study e testimonianze di valutazioni brand certificate',
      publisher: {
        '@type': 'Organization',
        name: 'Brand Capital',
        logo: {
          '@type': 'ImageObject',
          url: `${siteUrl}/logo.png`
        }
      }
    }
  });

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <CaseStudyHero />
      <CaseStudyList />
      <TestimonialsSection />
      <CTASection />
      <Footer />
    </div>
  );
}
